import SearchListItem from "./SearchListItem";

function SearchList({ posts }) {
  return (
    <div className="space-y-4">
      {posts.map((item) => (
        <SearchListItem key={item.document_id} item={item} />
      ))}
    </div>
  );
}

export default SearchList;
